import { RESERVED_TOP_LEVEL_SEGMENTS } from "../../../../domain/introducers/reservedSlugs";

const SLUG_RE = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;

// Shared with the API so the two stay in lock-step. We use only the
// top-level-segment set (not the fuller slug-creation reservation list)
// because login/dashboard/cases never appear as the FIRST URL segment.
const RESERVED_SEGMENTS = new Set<string>(RESERVED_TOP_LEVEL_SEGMENTS);

export const getIntroducerSlugFromUrl = (): string | undefined => {
    const segments = window.location.pathname.replace(/^\/+|\/+$/g, "").split("/");
    if (segments.length === 0) return undefined;
    const first = segments[0];
    if (!first) return undefined;
    if (RESERVED_SEGMENTS.has(first)) return undefined;
    return SLUG_RE.test(first) ? first : undefined;
};

export const introducerPortalBasePath = (): string => {
    const slug = getIntroducerSlugFromUrl();
    return slug === undefined ? "/introducer" : `/${slug}`;
};
